"use strict";

(function(z, Backbone){

    var TariffVendorAdminModel = Backbone.Model.extend({
        urlRoot: "/api/tariff-vendor-admin",
        serviceParamsFields: [],

        validation: {
            vendor: [{
                required: true,
                msg: Translator.trans("js.error_message_tariffVendor_vendor_required")
            }],
            service: [{
                required: true,
                msg: Translator.trans("js.error_message_tariffVendor_service_required")
            }],
            value: [{
                required: true,
                msg: Translator.trans("js.error_message_tariffVendor_value_required")
            },
                {
                    min: 1,
                    msg: Translator.trans('js.error_message_tariffVendor_value_format')
                }],
            dateStart: function(value) {
                if( typeof value == 'undefined' || ( typeof value !== 'undefined' && value == '')){
                    return Translator.trans("js.error_message_tariffVendor_dateStart_required");
                }
                var dateReg = /^\d{2}([-])\d{2}\1\d{4}$/;

                if(! value.match(dateReg)){
                    var now = new Date(value);
                    var day = ("0" + now.getDate()).slice(-2);
                    var month = ("0" + (now.getMonth() + 1)).slice(-2);
                    var date = (day) +"-"+(month)+"-" + now.getFullYear();
                    if(! date.match(dateReg)){
                        return Translator.trans("js.error_message_tariffVendor_dateStart_format");
                    }
                }
            }
            ,
            dateEnd: function(value) {
                if( typeof value == 'undefined' || ( typeof value !== 'undefined' && value == '')){
                    return Translator.trans("js.error_message_tariffVendor_dateEnd_required");
                }
                var dateReg = /^\d{2}([-])\d{2}\1\d{4}$/;

                if(! value.match(dateReg)){
                    var now = new Date(value);
                    var day = ("0" + now.getDate()).slice(-2);
                    var month = ("0" + (now.getMonth() + 1)).slice(-2);
                    var date = (day) +"-"+(month)+"-" + now.getFullYear();
                    if(! date.match(dateReg)){
                        return Translator.trans("js.error_message_tariffVendor_dateStart_format");
                    }
                }
            },
            allVendors: [{
                required: false,
            }],
        },

        /**
         * Parses the response and returns the appropriate data
         * @param {Object} response The reponse
         * @return {Object} The data
         */
        parse: function(response){

            return response.data;
        }
    });

    z.TariffVendorAdminModel = TariffVendorAdminModel;

})(window.z = window.z || {}, Backbone);